import { render, staticRenderFns } from "./UndoRedoSave.vue?vue&type=template&id=578a926d&"
import script from "./UndoRedoSave.vue?vue&type=script&lang=js&"
export * from "./UndoRedoSave.vue?vue&type=script&lang=js&"
import style0 from "./UndoRedoSave.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports